import store from '@/store';
const EventTemplate = () => import(/* webpackChunkName: "manage" */'@/components/pages/eventTemplate/EventTemplate');
const OperateEventTemplatePage = () => import(/* webpackChunkName: "manage" */'@/components/pages/eventTemplate/OperateEventTemplatePage');
const OrderNumRule = () => import(/* webpackChunkName: 'manage' */'@/components/pages/orderNumRule/OrderNumRule');
const BusinessConfig = () => import(/* webpackChunkName: "base" */'@/components/pages/business/BusinessConfig');
const SysConfig = () => import(/* webpackChunkName: "config" */'@/components/pages/sys/SysConfig');
const TopMenu = () => import(/* webpackChunkName: "base" */'@/components/common/TopMenu');
import announcement from './announcement';
import configuration from './configuration';
const routerMapping = {
  'WF_EVENT_TEMPLATES_QUERY': '/system/business/template',
  'SYS_ORDER_NUM_RULES_QUERY': '/system/business/order-num-rule',
  'SYS_ANNOUNCEMENT_QUERY': '/system/business/announcement-manage',
  'BUSINESS_RULE_QUERY': '/system/business/business-rule',
  'SYS_CONFIG_QUERY': '/system/business/initial-config',
  'CLASS_ATTRIBUTE_QUERY': '/system/business/classification-bench',
  'CLASS_ATTRIBUTE_RELATIONS_QUERY': '/system/business/relation',
  'WF_AUTO_DISPATCH_QUERY': '/system/business/dispatch-workbench'
} 
export default [
  {
    path: 'business',
    name: 'businessConfig',
    redirect: () => {
      let index = store.state.tab.workPages.findIndex(p => p.secondParent === '/system/business');
      if (index > -1) {
        return store.state.tab.workPages[index].routePath;
      } else {
        const roleIds = store.state.base.roleIds;
        let router = '/system/business/template';
        for (var item in routerMapping) {
          if (roleIds.includes(item)) {
            router = routerMapping[item];
            break;
          }
        }
        return router;
      }
    },
    component: TopMenu,
    meta: {
      title: '业务配置',
      roles: [
        'WF_EVENT_TEMPLATES_QUERY',
        'SYS_ORDER_NUM_RULES_QUERY',
        'SYS_ANNOUNCEMENT_QUERY',
        'SYS_CONFIG_QUERY',
        'BUSINESS_RULE_QUERY',
        'CLASS_ATTRIBUTE_QUERY',
        'CLASS_ATTRIBUTE_RELATIONS_QUERY',
        'WF_AUTO_DISPATCH_QUERY'
      ],
      activeMenu: '/system/business',
      componentName: 'TopMenu'
    },
    children: [
      {
        path: 'template',
        name: 'templateManage',
        meta: {
          roles: ['WF_EVENT_TEMPLATES_QUERY'],
          title: '事件模板',
          componentName: 'EventTemplate',
          breadcrumb: [
            {
              name: '事件模板',
              path: '/system/business/template'
            }
          ]
        },
        component: EventTemplate
      },
      {
        path: 'edit-template/:id',
        props: true,
        name: 'editTemplateManage',
        meta: {
          roles: ['WF_EVENT_TEMPLATES_UPDATE'],
          title: '编辑模板',
          hidden: true,
          activeMenu: '/system/business/template',
          componentName: 'OperateEventTemplatePage',
          breadcrumb: [
            {
              name: '事件模板',
              path: '/system/business/template'
            },
            {
              name: '编辑模板',
              path: '/system/business/edit-template/:id'
            }
          ]
        },
        component: OperateEventTemplatePage
      },
      {
        path: 'create-template',
        name: 'createTemplateManage',
        meta: {
          roles: ['WF_EVENT_TEMPLATES_ADD'],
          title: '新建模板',
          hidden: true,
          activeMenu: '/system/business/template',
          componentName: 'OperateEventTemplatePage',
          breadcrumb: [
            {
              name: '事件模板',
              path: '/system/business/template'
            },
            {
              name: '新建模板',
              path: '/system/business/create-template'
            }
          ]
        },
        component: OperateEventTemplatePage
      },
      {
        path: 'order-num-rule',
        name: 'orderNumRule',
        meta: {
          roles: ['SYS_ORDER_NUM_RULES_QUERY'],
          title: '单号规则',
          componentName: 'OrderNumRule',
          breadcrumb: [
            {
              name: '单号规则',
              path: '/system/business/order-num-rule'
            }
          ]
        },
        component: OrderNumRule
      },
      ...announcement,
      {
        path: 'business-rule',
        name: 'businessRule',
        meta: {
          roles: ['BUSINESS_RULE_QUERY'],
          title: '业务规则',
          componentName: 'BusinessConfig',
          breadcrumb: [
            {
              name: '业务规则',
              path: '/system/business/business-rule'
            }
          ]
        },
        component: BusinessConfig
      },
      {
        path: 'initial-config',
        name: 'initialConfig',
        meta: {
          roles: ['SYS_CONFIG_QUERY'],
          title: '初始配置',
          componentName: 'SysConfig',
          breadcrumb: [
            {
              name: '初始配置',
              path: '/system/business/initial-config'
            }
          ]
        },
        component: SysConfig
      },
      ...configuration
    ]
  }
];


// WEBPACK FOOTER //
// ./src/router/business.js